import styled from 'styled-components';

const FormHeading = styled.div`
display: flex;
width: 100%;
background: #fff;
${'' /* border-radius:6px; */}
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 133.333% */
color: ${({ color }) => color ? color : '#184A61'};
height:56px;
padding-left:0px;
align-items: center;
margin-bottom: 25px;

border-radius: 12px;
border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);

.close-icon{
    margin:0px 8px;
    cursor:pointer;
}
.end-card{
  display:flex;
  margin: auto 0 auto auto;
}
`;

const DateCard = styled.div`
display: flex;
width: 100%;
border: 1px solid ${({ disabled }) => disabled ? '#DCDCDC' : '#BDBDBD'};
border-radius:4px;
color: ${({ color, disabled }) => (color || disabled) ? '#BDBDBD' : '#184A61'};
background: ${({ disabled, background }) => disabled ? '#FEFEFE' : background ? '#EFEFEF' : 'transparent'};
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
padding: 14px 16px;
justify-content: space-between;
align-items: center;
>svg{
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
}
`;

const DateCardWrapper = styled.div`
display:flex;
gap:8px;
width:100%;
.startDate{
  width:450px;
  display:flex;
}
.endDate{
  width:450px;
  display:flex;
}
`;

const AddLinkContainer = styled.div`
display: flex;
width: 404px;
height: 126px;
padding: 16px;
flex-direction: column;
${'' /* justify-content: center; */}
align-items: flex-start;
border-radius: 6px;
border: 0.75px solid #DCDCDC;
background: #FEFEFE;
${'' /* margin-top:8px; */}
${'' /* gap: 20px; */}

.text{
  color: #184A61;
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 30px; 
margin-bottom:20px;
}
`

const ColorPickerWrapper = styled.div`
  margin-top: 20px;
`;

const ColorPickerBox = styled.div`
  width: 100%;
  height: 48px;
  border: 1px solid #da6c74;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: white;
  position: relative;
`;

const ColorPickerText = styled.span`
  color: #184a61;
  font-size: 16px;
  font-family: Lato;
`;

const ColorPreview = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${({ color }) => color || "#005C87"};
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  position: absolute;
  right: 12px;
`;

const HiddenColorInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
`;

export { FormHeading, DateCard, DateCardWrapper,AddLinkContainer,HiddenColorInput,ColorPreview,ColorPickerText,ColorPickerBox,ColorPickerWrapper }